<template>
  <div class="datadash-wrap">
    <div class="py-4 pb-0 container-fluid">
      <div class="section-header-card card">
        <div class="card-body p-0">
          <div class="row gx-4 align-items-center">
            <div class="col-auto my-auto">
              <h5 class="mb-0 header-title">Data Dashboards</h5>
              <p class="mb-0 text-xs text-muted">Please use the below filters to navigate the analytics</p>
            </div>
          </div>
          <div class="page-actions">
            <button
                v-for="tab in tabs"
                :key="tab.name"
                class="page-btn"
                :class="{ 'page-btn--active': activeTab === tab.name }"
                @click="activeTab = tab.name"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab content -->
    <div class="container-fluid datadash-content">
      <MarketDataDashboard v-if="activeTab === 'Market'" />
      <SupplyData         v-if="activeTab === 'Supply'" />
      <DemandData         v-if="activeTab === 'Demand'" />
      <PriceData          v-if="activeTab === 'Prices'" />
      <TradeData          v-if="activeTab === 'Trade'" />
      <CountryData        v-if="activeTab === 'Country'" />
      <TradeFlowData      v-if="activeTab === 'TradeFlow'" />
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { NTabs, NTabPane } from "naive-ui";
import SupplyData from "./SupplyData.vue";
import DemandData from "./DemandData.vue";
import PriceData from "./PriceData.vue";
import MarketDataDashboard from "./MarketDataDashboard.vue";
import { getSubscriptionInfo } from "../../composables/subscription";
import TradeData from "./TradeData.vue";
import CountryData from "./CountryData.vue";
import TradeFlowData from "./TradeFlowData.vue";
import { logUserAction, USER_ACTIONS } from "@/composables/userLogs";

const activeTab = ref("Market");

const tabs = [
  { name: "Market",     label: "Global Market Balance" },
  { name: "Supply",     label: "Supply"         },
  { name: "Demand",     label: "Demand"         },
  { name: "Prices",     label: "Prices"         },
  { name: "Trade",      label: "Trade"          },
  { name: "TradeFlow",  label: "Trade Flow"     },
  { name: "Country",    label: "Country Focus"  },
];

// Track when user switches between Data Dashboard tabs
watch(activeTab, (newTab) => {
  const tabObj = tabs.find(t => t.name === newTab);
  const tabLabel = tabObj ? tabObj.label : newTab;
  logUserAction(
    USER_ACTIONS.VIEW_DASHBOARD,
    `Viewed Data Dashboard tab: "${tabLabel}"`
  );
});

onMounted(async () => {
  await getSubscriptionInfo(false);
  // Record initial view of the Data Dashboards landing view
  logUserAction(
    USER_ACTIONS.VIEW_DASHBOARD,
    `Viewed Data Dashboards ("Global Market Balance")`
  );
});
</script>

<style lang="scss" scoped>
.datadash-wrap {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 70px);
  overflow: hidden;
  padding: 0;
}

.section-header-card {
  border: none;
  border-radius: 0;
  background: #fff;
  box-shadow: none;

  .header-title {
    font-size: 1rem;
    font-weight: 700;
    color: #000;
    font-family: 'GilroyBold', sans-serif;
  }
}

.card {
  box-shadow: none;
}

.page-actions {
  display: flex;
  gap: 0.25rem 3rem;
  padding: 0.5rem 0;
  flex-wrap: wrap;
}

.page-btn {
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  font-size: 14px;
  font-family: 'GilroyMedium', sans-serif;
  color: #000;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;

  &:hover:not(&--active) {
    color: #2184ff;
    text-decoration: underline;
    font-weight: 600;
  }

  &--active {
    color: #2184ff;
    font-family: 'GilroyMedium', sans-serif;
    font-weight: 600;
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.datadash-content {
  flex: 1;
  min-height: 0;
}
</style>